import React from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import CaseDetailsTable from "./CaseDetailsTable";

const DeleteTaskContent = ({
  taskConfig,
  caseId,
  caseDetails,
  isFetchingCase,
  isDeleting,
  isTakingBackup,
  isBackupTaken,
  backupFileName,
  noBackupData,
  deleteResponse,
  error,
  onCaseIdChange,
  onFetch,
  onTakeBackup,
  onDelete,
  onReset,
}) => {
  const isBusy = isFetchingCase || isDeleting || isTakingBackup;
  const hasCaseDetails = Boolean(caseDetails && caseDetails.caseId);
  const requiresBackup = taskConfig.requiresBackup;
  const canTakeBackup =
    requiresBackup &&
    hasCaseDetails &&
    !isBackupTaken &&
    !noBackupData &&
    !isBusy;
  const canDelete =
    hasCaseDetails &&
    (!requiresBackup || isBackupTaken) &&
    !noBackupData &&
    !deleteResponse &&
    !isBusy;

  return (
    <Card className="mt-3">
      <CardBody>
        <h5 className="mb-2">{taskConfig.sectionTitle}</h5>
        <p className="text-muted mb-3">{taskConfig.description}</p>
        <Alert color="info" className="py-2">
          <i className="fa fa-info-circle"></i>&nbsp;
          {requiresBackup
            ? "Step 1: Fetch case details. Step 2: Take backup. Step 3: Delete data."
            : "Step 1: Fetch case details. Step 2: Delete data."}
        </Alert>
        <Row>
          <Col sm={6}>
            <FormGroup>
              <Label for={`caseId-${taskConfig.deleteEndpoint}`}>
                Enter Case ID
              </Label>
              <Input
                type="text"
                name="caseId"
                id={`caseId-${taskConfig.deleteEndpoint}`}
                placeholder="Enter case ID"
                value={caseId}
                disabled={isBusy || Boolean(deleteResponse)}
                onChange={onCaseIdChange}
              />
            </FormGroup>
          </Col>
          <Col sm={12} className="d-flex align-items-end flex-wrap">
            <FormGroup>
              <Button
                color="primary"
                disabled={!caseId || isBusy || Boolean(deleteResponse)}
                onClick={onFetch}
              >
                {isFetchingCase ? (
                  <>
                    <i className="fa fa-spinner fa-spin"></i>&nbsp;Fetching...
                  </>
                ) : (
                  "Fetch"
                )}
              </Button>
              {requiresBackup && (
                <Button
                  color="warning"
                  style={{ marginLeft: 10 }}
                  disabled={!canTakeBackup}
                  onClick={onTakeBackup}
                >
                  {isTakingBackup ? (
                    <>
                      <i className="fa fa-spinner fa-spin"></i>&nbsp;Taking
                      Backup...
                    </>
                  ) : (
                    "Take Backup"
                  )}
                </Button>
              )}
              <Button
                color="danger"
                style={{ marginLeft: 10 }}
                disabled={!canDelete}
                onClick={onDelete}
              >
                {isDeleting ? (
                  <>
                    <i className="fa fa-spinner fa-spin"></i>&nbsp;Deleting...
                  </>
                ) : (
                  "Delete"
                )}
              </Button>
              <Button
                color="secondary"
                outline
                style={{ marginLeft: 10 }}
                disabled={isBusy}
                onClick={onReset}
              >
                Reset
              </Button>
            </FormGroup>
          </Col>
        </Row>

        {requiresBackup &&
          hasCaseDetails &&
          !isBackupTaken &&
          !noBackupData && (
          <Alert color="warning" className="mt-3 mb-0">
            <i className="fa fa-exclamation-triangle"></i>&nbsp;Please take
            backup before deleting data.
          </Alert>
          )}

        {noBackupData && (
          <Alert color="warning" className="mt-3 mb-0">
            <i className="fa fa-exclamation-triangle"></i>&nbsp;
            {error || "No deletable data available for this case."}
          </Alert>
        )}

        {requiresBackup && isBackupTaken && !deleteResponse && (
          <Alert color="success" className="mt-3 mb-0">
            <i className="fa fa-check-circle"></i>&nbsp;Backup taken successfully
            on S3{backupFileName ? ` (${backupFileName})` : ""}. You can now
            proceed with delete.
          </Alert>
        )}

        {deleteResponse?.message && (
          <Alert color="success" className="mt-3 mb-0">
            <i className="fa fa-check-circle"></i>&nbsp;{deleteResponse.message}
            {deleteResponse.deletedRecordsCount !== undefined &&
              deleteResponse.deletedRecordsCount !== null && (
                <>
                  <br />
                  Deleted records: {deleteResponse.deletedRecordsCount}
                </>
              )}
          </Alert>
        )}

        {error && !noBackupData && (
          <Alert color="danger" className="mt-3 mb-0">
            <i className="fa fa-exclamation-triangle"></i>&nbsp;{error}
          </Alert>
        )}

        <CaseDetailsTable caseDetails={caseDetails} />
      </CardBody>
    </Card>
  );
};

export default DeleteTaskContent;
